import Button from "@app/components/move2Library/Button/Button"
import { useGetStrings } from "@app/store/service/cmsService"
import { KioskBridge } from "@tecreation/bird5-kiosk-bridge"
import { Modal, useModal } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"

export default function TerminalMessageModal() {
	const {
		data: { buttonClose },
	} = useGetStrings(undefined, { defaultData: {} })
	const { hideModal } = useModal()
	let message = useSelector(state => state.order.ecMessage)

	return (
		<Modal>
			<Modal.Header>EC-Terminal</Modal.Header>
			<Modal.Body>
				<div className="f1 text-center">{message}</div>
			</Modal.Body>
			<Modal.Footer>
				<div className="flex flex-center">
					<Button
						onClick={async () => {
							await KioskBridge.execute("eft.abort", {})
							hideModal()
						}}
						style="primary"
					>
						{buttonClose}
					</Button>
				</div>
			</Modal.Footer>
		</Modal>
	)
}
